import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";
import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import ShowTerms from "../components/popups/ShowTerms";
import { ChangeMobileNumber,ChangeMobileFormat,unescapeHtml } from "../../components/common/Common";

import "../../css/style.css";

//비밀번호 찾기
const JoinUsBranch = () => {
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varMemberInfo,setMemberInfo] = useState({});
  const [varTerms,setTerms] = useState({});

  //약관정보 읽어오기
  const GetTermInformation = async () => {
    const res = await axios.post(`${process.env.REACT_APP_HOST}/branch_get_all_terms`);
    const datas = res.data;
    console.log(datas);
    if(datas.retvalue === 1) {
      const termObj = datas.results[0];
      setTerms(termObj);
    }
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    const newMemberInfo = {bh_id:"",bh_company:"EMPTY", bh_name:"",bh_mobile:"",bh_pwd:"",bh_pwd2:"",term_all:1,term_condition:1,term_privacy:1};
    setTerms({env_condition:"",env_privacy:""});
    setMemberInfo(newMemberInfo);
    setBranchMenus({showMenu:false,gotoMain:1});
    GetTermInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRegisterBranchHandler = async() => {
    if (varMemberInfo.bh_id === "") {
      alert('아이디를 먼저 입력하세요'); return false;  
    /* } else if (varMemberInfo.bh_company === "" ) {
      alert('가맹점명을 먼저 입력하세요'); return false;   */   
    } else if (varMemberInfo.bh_name === "" ) {
      alert('이름을 먼저 입력하세요'); return false;
    } else if (varMemberInfo.bh_mobile === "" ) {
      alert('휴대폰 번호를 먼저 입력하세요'); return false;
    } else if (varMemberInfo.bh_pwd === "" ) {
      alert('비밀번호를 먼저 입력하세요.'); return false;   
    } else if (varMemberInfo.bh_pwd2 === "") {
      alert('확인용 비밀번호를 먼저 입력하세요.'); return false;
    } else if (varMemberInfo.bh_pwd !== varMemberInfo.bh_pwd2) {
      alert('비밀번호와 확인용 비밀번호가 일치하지 않습니다.'); return false;
    }
    const sendData = {dataInfos:varMemberInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_register_information`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        navigate('/Branch/JoinUsOK');
      } else {
        alert(datas.message);
      }
    });
  }
  //입력값 처리
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === 'bh_mobile') {
      const svalue = ChangeMobileNumber(value);
      setMemberInfo({...varMemberInfo,[name]:svalue});
    } else {
      setMemberInfo({...varMemberInfo,[name]:value});
    }
  }

  //약관 팝업창 열기/닫기-------------------------------------------------------------------------------------
  const [varTermsWin,setTermsWin] = useState(false);
  const [varCurrentTerm,setCurrentTerm] = useState(0); 
  const onOpenTermsHandler = (e,imode) => {
    let termObj = {title:"",field:"",comment:""};
    switch(imode) {
      case 1: termObj = {title:"서비스 이용약관",field:"env_condition",comment:unescapeHtml(varTerms.env_condition)}; break;
      case 2: termObj = {title:"개인정보 수집 및 이용 동의",field:"env_privacy",comment:unescapeHtml(varTerms.env_privacy)}; break;
      default: break;
    }
    console.log(termObj);
    setCurrentTerm(termObj);
    setTermsWin(true);
  } 

  //약관 정체 선택유무
  const onCheckAllTermsHandler = (e) => {
    const bmode = e.currentTarget.checked;
    const imode = Number(bmode);
    setMemberInfo({...varMemberInfo,term_all:imode,term_condition:imode,term_privacy:imode})
  }
  //약관별 선택유무
  const onCheckedTermHandler = (e,ino) => {
    const { name } = e.currentTarget;
    const imode = Number(e.currentTarget.checked);
    setMemberInfo({...varMemberInfo,[name]:imode});
  }

  return (
    <div className="vh-content member-wrap">
      <HeaderBranchTitle varPageTitle={'회원가입'} varBackString={'/Branch/Login'}/>
      <div className="vh-content-body">
        <div className="join-form-wrap" style={{padding:"10px 5%"}}>
          <div className="form-group mb15">
            <label className="form-label">아이디</label>
            <div className="field-group">
              <input type="text" name="bh_id" value={varMemberInfo.bh_id||""} placeholder="아이디를 입력해주세요." className="form-control" onChange={onChangeInputHandler}/>
            </div>
          </div>
          {/* <div className="form-group mb15">
            <label className="form-label">가맹점명</label>
            <div className="field-group">
              <input type="text" name="bh_company" value={varMemberInfo.bh_company||""} placeholder="가맹점명을 입력해주세요." className="form-control" onChange={onChangeInputHandler}/>
            </div>
          </div> */}
          <div className="form-group mb15">
            <label className="form-label">성명</label>
            <div className="field-group">
              <input type="text" name="bh_name" value={varMemberInfo.bh_name||""} placeholder="성명을 입력해주세요." className="form-control" onChange={onChangeInputHandler}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">연락처 (- 제외 입력)</label>
            <div className="field-group">
              <input type="text" name="bh_mobile" value={ChangeMobileFormat(varMemberInfo.bh_mobile)} placeholder="휴대폰 번호를 입력하세요." className="form-control" onChange={onChangeInputHandler}/>
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">비밀번호 (4자리)</label>
            <div className="field-group is-invalid">
              <input type="password" name="bh_pwd" value={varMemberInfo.bh_pwd||""} placeholder="비밀번호를 입력하세요." maxLength={4} className="form-control" onChange={onChangeInputHandler} />
            </div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">비밀번호 확인</label>
            <div className="field-group is-invalid">
              <input type="password" name="bh_pwd2" value={varMemberInfo.bh_pwd2||""} placeholder="비밀번호를 다시 입력하세요." maxLength={4} className="form-control" onChange={onChangeInputHandler} />
            </div>
            <div className="invalid-tooltip">비밀번호와 동일하게 입력해주세요.</div>
          </div>
          <div className="form-terms">
            <div className="terms-all">
              <div className="checkbox">
                <input type="checkbox"  name="checkAll" id="checkAll" checked={varMemberInfo.term_all===1} onChange={e=>onCheckAllTermsHandler(e)}/>
                <label htmlFor="checkAll">서비스 이용약관 전체 동의</label>
              </div>
            </div>
            <div className="terms-list-wrap">
              <div className="terms-list">
                <div className="checkbox">
                  <input type="checkbox" name="term_condition" id="checkBox1" className="chkterm" checked={varMemberInfo.term_condition===1} onChange={e=>onCheckedTermHandler(e,1)}/>
                  <label htmlFor="checkBox1">(필수) 이용약관에 동의합니다.</label>
                </div>
                <button className="terms-link terms" onClick={e=>onOpenTermsHandler(e,1)}>보기</button>
              </div>
              <div className="terms-list">
                <div className="checkbox">
                  <input type="checkbox" name="term_privacy" id="checkBox2" className="chkterm" checked={varMemberInfo.term_privacy===1} onChange={e=>onCheckedTermHandler(e,2)}/>
                  <label htmlFor="checkBox2">(필수) 개인정보 취급방침에 동의합니다.</label>
                </div>
                <button className="terms-link privacy" onClick={e=>onOpenTermsHandler(e,2)}>보기</button>
              </div>              
            </div>
          </div>
          <div className="form-contoller bt-btn">
            <Link to="/Branch/Login" className="form-contoller-btn btn-no">취소</Link>
            <button className="form-contoller-btn btn-yes" onClick={onRegisterBranchHandler}>회원가입</button>
          </div>
        </div>	
      </div>	
      <ShowTerms varTermsWin={varTermsWin} setTermsWin={setTermsWin} varCurrentTerm={varCurrentTerm}/>
    </div>	
  );
}
export default JoinUsBranch;